import { preChat } from './preChat';

const es = {
  ...preChat,
};

export default es;
